"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MemoField = void 0;
var React = _interopRequireWildcard(require("react"));
var _excluded = ["component"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var MemoField = exports.MemoField = /*#__PURE__*/React.memo(function (_ref) {
  var component = _ref.component,
    props = _objectWithoutProperties(_ref, _excluded);
  var FieldComponent = component;
  return /*#__PURE__*/React.createElement(FieldComponent, props);
}, function (prev, next) {
  // only re-render field if props change
  var propsAreSame = areEqualShallow(prev, next, ["onChange"]); // onChange has different ref every render for some reason
  if (!propsAreSame) {
    //console.log(prev, next);
  }
  return propsAreSame;
});
function areEqualShallow(a, b, skip) {
  for (var key in a) {
    if (skip && skip.includes(key)) {
      continue;
    }
    if (a[key] !== b[key]) {
      //console.log(key, a[key], b[key])
      return false;
    }
  }
  return true;
}
var _default = exports["default"] = MemoField;